module.exports = __webpack_public_path__ + "media/categories/2012-824461a2.svg";